import AttentionIcon from './component'

export default AttentionIcon
